module.exports = __webpack_public_path__ + "img/b_alatbywema@2x.b109f022.png";